// Claims Reporting Reducer

import {
  SAVE_CLAIMS_REPORT_PARAMETERS_SUCCESS,
  SAVE_CLAIMS_REPORT_PARAMETERS_FAILURE,
  SAVE_CLAIMS_REPORT_PARAMETERS_LOADING,
  GENEREATE_PREVIEW_CLAIMS_REPORT_SUCCESS,
  GENEREATE_PREVIEW_CLAIMS_REPORT_FAILURE,
  GENEREATE_PREVIEW_CLAIMS_REPORT_LOADING,
  FETCH_SAVED_CLAIMS_REPORTS_SUCCESS,
  FETCH_SAVED_CLAIMS_REPORTS_FAILURE,
  FETCH_SAVED_CLAIMS_REPORTS_LOADING,
  UPDATE_CLAIMS_REPORTING_FIELDS,
  RESET_REPORT_STATE,
  REMOVE_CLAIMS_REPORT_SUCCESS,
  REMOVE_CLAIMS_REPORT_FAILURE,
  REMOVE_CLAIMS_REPORT_LOADING,
  RESET_REMOVE_REPORT_STATE,
  GENERATE_CONVERSATION_SUCCESS,
  GENERATE_CONVERSATION_FAILURE,
  GENERATE_CONVERSATION_LOADING,
  FETCH_SINGLE_CLAIMS_REPORT_SUCCESS,
  FETCH_SINGLE_CLAIMS_REPORT_FAILURE,
  FETCH_SINGLE_CLAIMS_REPORT_LOADING,
  PRE_SELECT_TEMPLATE_FIELDS,
} from '@src/middleware/actions/actionTypes';

import { getDefaultSelectedFields } from '@src/apps/Reimbursement/ClaimsReporting/helpers';

const emptyReportState = {
  id: '',
  providerSysKey: '',
  pageName: '',
  cardName: '',
  reportName: '',
  fromDate: '',
  toDate: '',
  timePeriod: '',
  lob: '',
  selectedFields: [],
};

const initialState = {
  data: {
    id: '',
    providerSysKey: '',
    pageName: '',
    cardName: '',
    reportName: '',
    fromDate: '',
    toDate: '',
    timePeriod: '',
    lob: '',
    selectedFields: [],
  },
  mode: 'create',
  loading: false,
  isGeneratingPreview: false,
  error: null,
  previewReport: null,
  savedReports: [],
  isReportSaved: false,
  isReportRemoved: false,
  claimsReportData: [],
};

const ClaimsReportingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_SAVED_CLAIMS_REPORTS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case FETCH_SAVED_CLAIMS_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        savedReports: action.payload,
      };
    case FETCH_SAVED_CLAIMS_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_CLAIMS_REPORTING_FIELDS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.field]: action.payload.value,
        },
        claimsReportData: [],
      };

    case GENEREATE_PREVIEW_CLAIMS_REPORT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case GENEREATE_PREVIEW_CLAIMS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        previewReport: action.payload,
      };
    case GENEREATE_PREVIEW_CLAIMS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SAVE_CLAIMS_REPORT_PARAMETERS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SAVE_CLAIMS_REPORT_PARAMETERS_SUCCESS:
      return {
        ...state,
        loading: false,
        isReportSaved: true,
      };
    case SAVE_CLAIMS_REPORT_PARAMETERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case RESET_REPORT_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        previewReport: null,
        isReportSaved: false,
        isGeneratingPreview: false,
        mode: 'create',
        data: { ...emptyReportState },
        claimsReportData: [],
      };

    case REMOVE_CLAIMS_REPORT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case REMOVE_CLAIMS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        isReportRemoved: true,
      };
    case REMOVE_CLAIMS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case RESET_REMOVE_REPORT_STATE:
      return {
        ...state,
        isReportRemoved: false,
      };

    case GENERATE_CONVERSATION_LOADING:
      return {
        ...state,
        isGeneratingPreview: action.payload,
      };
    case GENERATE_CONVERSATION_SUCCESS:
      return {
        ...state,
        isGeneratingPreview: false,
        claimsReportData: action.payload,
      };
    case GENERATE_CONVERSATION_FAILURE:
      return {
        ...state,
        isGeneratingPreview: false,
        error: action.payload,
        claimsReportData: [],
      };
    case FETCH_SINGLE_CLAIMS_REPORT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case FETCH_SINGLE_CLAIMS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        mode: 'edit',
        data: action.payload,
      };
    case FETCH_SINGLE_CLAIMS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PRE_SELECT_TEMPLATE_FIELDS:
      return {
        ...state,
        data: {
          ...state.data,
          selectedFields: getDefaultSelectedFields(action.payload),
        }
      };

    default:
      return state;
  }
};

export default ClaimsReportingReducer;